export default __webpack_public_path__ + "static/media/loading.a11198ec.gif";